import { useQuery } from '@tanstack/react-query';
import { api } from '~/lib/api-client';
import { dayOneKeys } from '~/lib/query-keys';

/**
 * FRONT-907: the caller's day-one activation state. Null session id means the
 * user never went through day-one activation (pre-feature accounts included).
 */
export interface DayOneState {
  sessionId: string | null;
  proposalStatus: 'pending' | 'accepted' | 'declined' | null;
  chatStatus: 'pending' | 'completed' | 'abandoned' | null;
  starterCronIds: string[] | null;
  /**
   * FRONT-1014 (Marko, live-test): the shared "is the interview recap
   * decided" signal — same one `getInterviewNudgeState` (inbox nudge) and
   * `buildDayOnePromptBlock` (day-one prompt gate) already use, covering
   * BOTH recap paths (the reflect-based text recap AND the voice
   * save-proposal) so all three surfaces agree. `day-one-chat.tsx`'s
   * `computeReadyForEnterEddy` reads this instead of re-deriving its own
   * voice-only version, which used to misread "no voice proposal exists"
   * (every text-only interview) as "decided".
   */
  interviewRecapDecided: boolean;
}

export function useDayOneState(enabled = true) {
  return useQuery({
    queryKey: dayOneKeys.state(),
    queryFn: () => api.get<DayOneState>('/api/onboarding/day-one'),
    enabled,
    staleTime: 30_000,
  });
}
